import TravelFilterPage from '@/components/pages/TravelFilterPage'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import graphQLClient from '@/lib/api/graphQLClient'
import { buildTravelFilterRequestVariables, TRAVEL_FILTER_QUERY } from '@/features/travelFilter/gql'
import { useAppDispatch } from '@/app/hooks'
import { applyTravelFilterUrlQuery, setInitialTravelFilterResponse } from '@/features/travelFilter'
import { TravelFilterResponse } from '@/features/travelFilter/types'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { useTranslation } from 'next-i18next'

interface Props {
  filterResponse: TravelFilterResponse
}

const TravelFilter = ({ filterResponse }: Props) => {
  const { t } = useTranslation('common')

  const dispatch = useAppDispatch()
  const router = useRouter()
  useEffect(() => {
    // set initial data
    dispatch(setInitialTravelFilterResponse({ filterResponse: filterResponse }))

    // load from URL query string
    setTimeout(() => {
      dispatch(applyTravelFilterUrlQuery({ filterResponse: filterResponse, router: router }))
    }, 20)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Head>
        <title>{t('pages.travelFilter.seo.title')}</title>
        <meta name="description" content={t('pages.travelFilter.seo.description')} />
        <meta property="og:title" content={t('pages.travelFilter.seo.title')} />
        <meta property="og:description" content={t('pages.travelFilter.seo.description')} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('pages.travelFilter.seo.title')} />
        <meta name="twitter:description" content={t('pages.travelFilter.seo.description')} />
      </Head>
      <TravelFilterPage initialTravels={filterResponse.travels} />
    </>
  )
}

export async function getStaticProps({ locale }: any) {
  const filterResponse = await graphQLClient.request(TRAVEL_FILTER_QUERY, buildTravelFilterRequestVariables()).then((response) => {
    return response.travelFilter
  })

  return {
    props: {
      filterResponse: filterResponse,
      ...(await serverSideTranslations(locale, ['common', 'theme'])),
    },
    revalidate: 60,
  }
}

export default TravelFilter
